<template>
  <div class="pdf-checklist-amostra">
    <g-card
    :temCabecalho = "false"
    :temBordaTopProps="false"
    >
      <div class="espacamento-pdf">
        <div class="titulo-grupo-detalhes "> Checklist de Amostra / Lote </div>
        <div class="grupo-dados-checklist">
          <div class="dados-checklist-formulario">
              <div class="titulo-conteudo-detalhes"> Formulário </div>
              <div class="label-conteudo"> {{ ChecklistArray.formulario }} </div>
          </div>
          <div class="dados-checklist-pedido">
              <div class="titulo-conteudo-detalhes"> Pedido </div>
              <div class="label-conteudo"> {{ ChecklistArray.numeroPedido }} </div>
          </div>
          <div class="dados-checklist-consumo">
              <div class="titulo-conteudo-detalhes"> *Consumo previsto para o produto: {{ ChecklistArray.descricaoConsumo }} - {{ ChecklistArray.dataConsumoTexto }} </div>
              <div v-if="ChecklistArray.produtoIndustrializacaoComercializacao == true" class="label-conteudo"> -Produto será utilizado no processo de industrialização ou comercialização </div>
              <div v-if="ChecklistArray.aprovacaoEmMateriaPrima == true" class="label-conteudo"> - Aprovação de matéria-prima </div>
              <div v-if="ChecklistArray.necessidadeTecnica == true" class="label-conteudo"> - Necessidade técnica do Grupo </div>
              <div class="label-conteudo"> {{ ChecklistArray.observacoes }}</div>
              <div class="label-conteudo"> {{ ChecklistArray.outros }}</div>


              

          </div>
          <div class="grupo-dados-checklist-data">
            <div class="dados-checklist-usuario">
              <div class="titulo-conteudo-detalhes"> Usuário </div>
              <div class="label-conteudo"> {{ ChecklistArray.usuarioNome }} </div>
            </div>
            <div class="dados-checklist-data">
                <div class="titulo-conteudo-detalhes"> Data </div>
                <div class="label-conteudo"> {{ ChecklistArray.dataDigitacaoFormatada }} </div>
            </div>
            <div class="dados-checklist-hora">
                <div class="titulo-conteudo-detalhes"> Hora </div>
                <div class="label-conteudo"> {{ ChecklistArray.horaDigitacaoFormatada }} </div>
            </div>
          </div>
        </div>
      </div>
    </g-card>
  </div>
</template>

<script>
import ChecklistAmostraLotePDF from "./ChecklistAmostraLotePDF.js";
export default ChecklistAmostraLotePDF;
</script>

<style scoped>
  .grupo-dados-checklist{
    display: flex;
    flex-direction: column;
  }
  .grupo-dados-checklist-data{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
</style>